import { useNavigate } from "react-router-dom";
import SecondHeader from '../components/headers/SecondHeader'
import { useContextState } from '../context/Context';
import LoginModal from '../components/modals/LoginModal';
import CacheClear from "../components/cache/CacheClear";
import Footer from '../components/footers/Footer'
import ApplicationBar from "../components/shared/ApplicationBar";

const Cache = () => {
  const { accountCTX, cacheCTX } = useContextState();
  const { signedIn } = accountCTX
  const { setCacheState } = cacheCTX

  const navigate = useNavigate();

  document.title = `FestiShare Support: Cache!`


  return (
    <div className="">
      {!signedIn? 
          <LoginModal close={true} closeButton={() => navigate('/')} back={() => navigate('/')}/>
          :
        <div>
          <SecondHeader headerType='cache' callBack={setCacheState} />
          <CacheClear />
        </div>
      } 
      <Footer />
      <ApplicationBar />
    </div>
  )
}

export default Cache